import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { Buttons, formConfig } from "./ReporteLiderComercial.form";
import { ReporteLiderComercialTable } from "./ReporteLiderComercial.table";
import {
  ReporteLiderComercialMockUp,
  ResumenLiderComercialMockUp
} from "./ReporteLiderComercial.types";
import { mockData, mockResumen } from "./ReporteLiderComercial.data";
import Layout from "../../layout";
import { Helmet } from "react-helmet";
import { successNotification } from "../../../../utils/notifications";

interface State {
  data: ReporteLiderComercialMockUp[];
  resumen: ResumenLiderComercialMockUp | null;
}

export default class ReporteLiderComercialComponent extends Component<
  {},
  State
> {
  state: State = {
    data: [],
    resumen: null
  };

  handleSubmit = (values: any) => {
    this.setState({
      data: mockData,
      resumen: mockResumen
    });

    successNotification("Cargado correctamente");
  };

  handleExport = () => {
    successNotification("Exportado correctamente");
  };

  onChange = (_values: any) => {
    // Placeholder para onChange
  };

  render() {
    const { resumen, data } = this.state;

    return (
      <main>
        <Layout>
          <Helmet title="Mockup" />
          <Container>
            <FormBuilder
              config={formConfig}
              submit={this.handleSubmit}
              onChange={this.onChange}
            ></FormBuilder>

            {resumen && (
              <Row className="mb-4">
                <Col md={3}>
                  <Card>
                    <CardBody className="text-center">
                      <h3>{resumen.operaciones}</h3>
                      <p>Operaciones</p>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card>
                    <CardBody className="text-center">
                      <h3>{resumen.descuentos}</h3>
                      <p>Descuentos</p>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card>
                    <CardBody className="text-center">
                      <h3>{resumen.alcance}%</h3>
                      <p>Alcance</p>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card>
                    <CardBody className="text-center">
                      <h3>{resumen.meta}</h3>
                      <p>Meta</p>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}

            {data.length > 0 && (
              <ReporteLiderComercialTable
                data={data}
                onExport={this.handleExport}
              />
            )}
          </Container>
        </Layout>
      </main>
    );
  }
}
